export const FETCH_WORK_ORDER_NAME_REQUEST = 'FETCH_WORK_ORDER_NAME_REQUEST';
export const FETCH_WORK_ORDER_NAME_SUCCESS = 'FETCH_WORK_ORDER_NAME_SUCCESS';
export const FETCH_WORK_ORDER_NAME_ERROR = 'FETCH_WORK_ORDER_NAME_ERROR';
